// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__4lsge","top":"styles_top__1apWq"};